export default __webpack_public_path__ + "static/Gautam-4abadac199aabf7a9a62a3d4e893fffb.jpg";